import { useRef, useState, useLayoutEffect } from 'react'
import PlayButton from 'components/common/buttons/playButton'
import PauseButton from 'components/common/buttons/pauseButton'
import BookingWidget from 'components/booking/widget/bookingWidget'
import HomeMainLogo from 'components/home/homeMainLogo'
import { MainContainer, HeroVideo, HeroImage, TextContainer, Divider, UpperText, MainText, VideoOverlay, ButtonContainer, BookingWidgetContainer } from './hero_styles'
import { ConditionalDiv } from 'components/common/common_styles'

const Hero = ({ data, showBookingWidget, home }) => {
  const [isPaused, setIsPaused] = useState(false)
  const [textScaleFactor, setTextScaleFactor] = useState(1)
  const desktopVideoRef = useRef()
  const mobileVideoRef = useRef()
  const primaryTextRef = useRef()

  useLayoutEffect(() => {
    const gutterInt = Math.min(Math.max(24, window.innerWidth * 0.071429 - 22.86), 80)
    const textWidth = primaryTextRef.current?.clientWidth
    const availableWidth = window.innerWidth - 2 * gutterInt - 16
    setTextScaleFactor(Math.min(1, availableWidth / textWidth))
  }, [])

  const playOrPause = ref => () => {
    setIsPaused(!ref.current?.paused)
    ref.current?.paused ? ref.current?.play() : ref.current?.pause()
  }

  return (
    <MainContainer>
      <ConditionalDiv desktopOnly>
        {data.primary.desktop_video?.url ?
          <>
            <HeroVideo
              autoPlay
              loop
              muted
              width='100%'
              playsInline
              poster={data.primary.desktop_image.url}
              ref={desktopVideoRef}
            >
              <source src={data.primary.desktop_video.url} type='video/mp4' />
            </HeroVideo>
            <VideoOverlay />
            <ButtonContainer>
              {isPaused && <PlayButton onClick={playOrPause(desktopVideoRef)} />}
              {!isPaused && <PauseButton onClick={playOrPause(desktopVideoRef)} />}
            </ButtonContainer>

          </>
          :
          <HeroImage data={data.primary.desktop_image} />
        }
      </ConditionalDiv>
      <ConditionalDiv mobileOnly>
        {data.primary.mobile_video?.url ?
          <>
            <HeroVideo
              autoPlay
              loop
              muted
              width='100%'
              playsInline
              poster={data.primary.mobile_image.url}
              ref={mobileVideoRef}
            >
              <source src={data.primary.mobile_video.url} type='video/mp4' />
            </HeroVideo>
            <VideoOverlay />
            <ButtonContainer>
              {isPaused && <PlayButton onClick={playOrPause(desktopVideoRef)} />}
              {!isPaused && <PauseButton onClick={playOrPause(desktopVideoRef)} />}
            </ButtonContainer>
          </>
          :
          <HeroImage data={data.primary.mobile_image} />
        }
      </ConditionalDiv>
      <TextContainer home={home}>
        {home ?
          <HomeMainLogo />
          :
          <>
            <UpperText>{data.primary.welcome}</UpperText>
            <Divider />
            <MainText ref={primaryTextRef} scale={textScaleFactor}>{data.primary.title}</MainText>
          </>
        }
      </TextContainer>
      {showBookingWidget &&
        <BookingWidgetContainer>
          <BookingWidget home />
        </BookingWidgetContainer>
      }
    </MainContainer>
  )
}

export default Hero
